/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('DocumentReaderCtrl', function($scope, $sce) {

    const load_file = function(file) {
        $scope.file_url  = $sce.trustAsResourceUrl(file.url);
        return $scope.file_name = file.name;
    };

    // init load
    load_file($scope.file);

    return $scope.$on('file_update', (event, file) => load_file(file));
});
